import { single } from "rxjs/operators";
import { AnaColumn, dynamicGrid } from "../forms-template.service";
import { aspect } from "./aspect";
import { SettingGrid, createGridConfig } from "./gridSettings/gridSettings";
const settingGridGeneric : SettingGrid= {
  masterKey: 'id',
  keyUnique: '',
  mode: null,
  selectionMode: 'single',
  remoteOperations: true,
  hoverStateEnabled: true,
  rowAlternationEnabled: true,
  repaintChangesOnly: true,
  showFilterSearch: false,
  allowUpdating: false,
  allowDeleting: false,
  allowAdding: false,
  height: 630,
  showColBlank: false,
  colonne: [
    {
      dataField: 'id',
      dataType: '',
      caption: 'Codice',
      allowEditing: true,
      colWidth: '60px'
    },
    {
      dataField: 'descrizione',
      dataType: '',
      caption: 'Descrizione',
      allowEditing: true,
      colWidth: '560px'
    },
  ],

}
const settingTestiAdr : SettingGrid = {
  masterKey: 'id',
  keyUnique: '',
  mode: null,

  selectionMode: 'single',
  remoteOperations: true,
  hoverStateEnabled: true,
  rowAlternationEnabled: false,
  repaintChangesOnly: true,
  showFilterSearch: false,
  allowUpdating: true,
  allowDeleting: true,
  allowAdding: false,
  height: 500,
  showColBlank: false,
  toolbarButtons: [
    {
      name: 'nuovoSoggetto',
      hint: "Inserisci una nuovo Testo ADr",
      icon: "glyphicon export icon-plus-circled",
      location: 'after',
      text: 'Nuovo Testo ADR',
      type: 'icon',
      event: 'nuovoSoggetto',
      disabled: false,
      class: '',
      accesskey: 'N',
      visible: true
    },

  ]


}
const settingGridDeiDocumenti  : SettingGrid= {

  campoTabRif: 'nomeTabella', // in questo caso lo lascio vuoto in quanto la griglia non deve effettuare operazioni salvataggio
  masterKey: 'id',
  keyUnique: '',
  mode: 'cell',
  selectionMode: 'single',
  rowAlternationEnabled: true,
  repaintChangesOnly: false,
  remoteOperations: true,
  hoverStateEnabled: true,
  allowUpdating: true,
  allowDeleting: true,
  allowAdding: true,
  showFilterSearch: false,
  searchAndSelect: false, //Cerca Valore e seleziona
  height: 700,
  showColBlank: true,
  colonne: [
    {
      dataField: 'index',
      dataType: '',
      caption: ' ',
      width: 20,
      allowEditing: false,
      showEditorAlways: false,
    },


    {
      dataField: 'descrizione',
      dataType: '',
      caption: 'Descrizione',
      allowEditing: true,
    },

    {
      dataField: 'nomeTabella',
      dataType: '',
      caption: 'Nome tabella',
      defaultValue: 'Movimenti',
      allowEditing: false,
      showEditorAlways: false,
      colVisible: false
    },


  ]

}

const newLocal = false;

export const stampaRegistriMovimenti: AnaColumn[] = [

  {
    configuration:
    {
      titleGriglia: 'Registro carico e scarico rifiuti',
      titleForm: 'Registro carico e scarico rifiuti ',
      breadcrumbCaption: 'Registro carico e scarico rifiuti',
      campoTitle: ['causaleDesc', 'posizioneDesc'],
      service: 'movimentiRifiuto',
      api: 'MovimentoRifiuti',
      filterList: '?$count=true&$orderby=DataRegistrazione&$orderby=Contatore',
      filterEditor: '/$',
      helpDoc: 'Registrodicaricoescaricorifiuti.html',
      formType: 'simple',
      queryFilter: [],
      idTabRif: [],

      masterKey: 'id',
      nCol: 2,
      toolbarSettings: {
        service: 'movimentiToolbar',

      }

    }

  },

  {
    itemType: "group", caption: "", class: '', groupDataField: 'dati-generali-movimento', colCount: "4", data: [

      {
        type: 'button',
        colVisible: false,
        orderGriglia: 1,
        colSpan: '4',
        dataField: "mostraScaricoR",
        class: 'text-center scarchi-click',
        caption: "",
        hideOnEdit: true,
        button: {
          text: 'mostraScaricoR',
          name: 'mostraScaricoR',
          location: 'after',
          class: 'scarchiClick',
          event: "scarchiClick",
          hint: "Mostra carichi relazionati",
          icon: 'glyphicon  icon-mostra_password',
          outPutValue: false,

        }
      },

      {
        type: 'campo', dataField: "id", dataType: "", caption: "Codice",
        colVisible: false,
        hideOnEdit: true,
        orderGriglia: 1,
        nCol: '10',
        colSpan: '4',
      },


      {
        type: 'campo', dataField: "causale_Id_Operazione", dataType: "", caption: "Operazione",
        colVisible: false,
        hideOnEdit: true,
        orderGriglia: 1,
        nCol: '10',
        colSpan: '4',
        colWidth: 90,
      },
      {
        type: 'campoButton', dataField: "causale_Descrizione", dataType: "", caption: "Causale",
        colVisible: false,
        nCol: '10',
        disableOnUpdate: true,
        colSpan: '4',
        width: '34.2vw',
        labelWidth: 7,

        buttons: [{
          text: '',
          name: 'newCausale',
          location: 'after',
          event: "newCausaleButtonClick",
          hint: "Seleziona una nuova causale",
          icon: "glyphicon mdi mdi-playlist-plus",
          outPutValue: false,


        },
        {
          text: '',
          name: 'viewRegistri',
          location: 'after',
          event: "registriCausaleButtonClick",
          hint: "Visualizzi i registri",
          icon: "glyphicon mdi mdi-file-search-outline",
          outPutValue: false,


        }
        ],
      },
      {
        allowFiltering: true,
        type: 'campoData',
        dataType: 'date',
        dataField: 'dataRegistrazione',
        caption: 'Data R.',
        colVisible: true,
        format: "dd/MM/yyyy",
        editorType: "dxDateBox",
        colWidth: '84',
        orderGriglia: 2,
        width: '5vw',
        nCol: '3',
      
        showClearButton: false,
      },
      {
        type: 'campo', dataType: '', dataField: 'protocollo', caption: 'Prot. Attuale',
        colVisible: true, maxLength: '10', colWidth: '102', orderGriglia: 3, width: '5.2vw', nCol: '4', hideOnEdit: true,
      },


      {
        allowFiltering: true,
        type: 'campoData', dataType: 'date', dataField: 'dataFormulario', caption: 'Data Doc',
        format: "dd/MM/yyyy",
        editorType: "dxDateBox",
        class: 'data-doc-fir',
        showClearButton: false,
        colVisible: true,
        width: '5vw',
        nCol: '3',
        orderGriglia: 4,
      },
      {
        type: 'campo', dataType: '', dataField: 'numDocumentoInterno', caption: 'Nr. Doc',
        maxLength: '20', maxSize: 20, colWidth: '124',
        orderGriglia: 2,
        colVisible: false,
        width: '7.4vw', class: 'num-fir',
        nCol: '3'
      },

      {
        type: 'campo', dataType: '', dataField: 'riferimentoDocumento', caption: 'Riferimento',
        colVisible: true, maxLength: '15', colWidth: '130', orderGriglia: 5, width: '5.7vw',
        class: 'rif-doc',
        nCol: '3'
      },
      {
        type: 'campo', dataField: "quantitaKg", dataType: "", caption: "Peso netto Kg",
        /* format: '#,##0', */

        colCaption: 'Peso',
        width: '5.5vw',
        orderGriglia: 9,

        maxLength: "11",
        colVisible: true,
        colWidth: '112',
        labelVisible: true,
        editorType: 'dxNumberBox',
        class: 'warning-qta quantita-origine',
        colAlignment: 'right',
        validation: [
          { type: 'required', message: 'Peso obbligatorio' }
        ]
      },
      {
        type: 'campo', dataField: "scontrino", dataType: "", caption: "Scontr",
        width: '5.5vw',
        maxLength: "10",
        colVisible: true,
        colWidth: '100',
        labelVisible: true,
        orderGriglia: 6,
      },

      {
        type: 'campoData',
        dataType: 'time',
        dataField: 'oraRegistrazione',
        caption: 'Ora reg.',
        labelWidth: 5,
        colVisible: false,
        width: '3.5vw',
        editorType: "dxDateBox",
        colWidth: '15',
        format: 'HH:mm',
        mask: 'HH:mm',
        showClearButton: false,
        nCol: '2',
      },
      {
        allowFiltering: true,
        type: 'campoData', dataType: 'date', dataField: 'dataDocumentoInterno', caption: 'Data doc.Interno ',
        colVisible: false, format: "dd/MM/yyyy", editorType: "dxDateBox", colWidth: '125', orderGriglia: 3, showClearButton: false,
        width: '5vw', class: 'data-doc-interno',

        nCol: '4',
      },
      {
        type: 'campo', dataType: '', dataField: 'numDocumentoInterno', caption: 'N.doc',
        colVisible: true, maxLength: '10', colWidth: '102', orderGriglia: 4, width: '5.2vw', nCol: '4',
      },
      {
        type: 'campo', dataType: '', dataField: 'numeroFormulario', caption: 'Nr. Formulario',
        maxLength: '20', maxSize: 20, colWidth: '124',
        orderGriglia: 5,
        colVisible: true,
        width: '7.4vw', class: 'num-fir',
        nCol: '3'
      },
      { type: 'empty', dataType: '', dataField: '', caption: '', class: '', },



      { type: 'empty', caption: ' ', colSpan: '4', dataField: '', dataType: '' },

      /**Cliente**/

      {
        type: 'campoSpecial',
        colVisible: false,
        dataField: "idCliente",
        caption: "Cliente",
        class: 'd-none',
        colSpan: '4',
        dynamic: {
          valueExpr: '',
          queryString: 'id',
          displayExpr: '',
          dataSource: 'Sede?id=',
          autocomplete: false,
          checkValue: {
            checkValueMessage: '',
            forceInsert: false
          },
          caption: "Lista Autorizzazioni",
          componentType: 'grid',


        }

      },
      {
        type: 'campoSpecial', dataField: "cliente_Descrizione", dataType: "", caption: "Cliente",
        colVisible: false,
        disableOnUpdate: false,
        colSpan: '4',
        nCol: '10',

        width: '33.5vw',
        editorClass: 'cliente-desc',

        dynamic: {
          dataSource: "Sede",
          service: 'sede',
          autocomplete: true,
          checkValue: {
            checkValueMessage: '',
            forceInsert: false
          },
          valueExpr: '',
          displayExpr: 'descrizione',
          searchExpr: 'descrizioneSoggetto',
          caption: "Lista Produttori",
          queryString: '',
          componentType: 'grid',
          enableEditor: {
            add: true,
            remove: false,
            update: true
          },
          buttonOption: {
            text: 'Zone',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Cliente',
            name: 'cliente',
            location: 'after',
          },


        }
      },

      {
        type: 'campoSpecial', dataField: "contratto_Descrizione", dataType: "", caption: "Contratto",
        colVisible: false,
        disableOnUpdate: false,
        editorClass: 'cliente-desc',
        width: '15vw',
        nCol: '5',
        dynamic: {
          dataSource: "Sede",
          service: 'sede',
          autocomplete: true,
          checkValue: {
            checkValueMessage: '',
            forceInsert: false
          },
          valueExpr: '',
          displayExpr: 'descrizione',
          searchExpr: 'descrizioneSoggetto',
          caption: "Lista Produttori",
          queryString: '',
          componentType: 'CerComponent',

          buttonOption: {
            text: 'Zone',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Cliente',
            name: 'cliente',
            location: 'after',
          },


        }
      },
      {
        type: 'campoSpecial', dataField: "addebito_Descrizione", dataType: "", caption: "Addebiti",
        colVisible: false,
        disableOnUpdate: false,
        class: 'label-soggetti',
        width: '13.7vw',
        nCol: '5',
        dynamic: {
          dataSource: "Sede",
          service: 'sede',
          autocomplete: true,
          checkValue: {
            checkValueMessage: '',
            forceInsert: false
          },
          valueExpr: '',
          displayExpr: 'descrizione',
          searchExpr: 'descrizioneSoggetto',
          caption: "Lista Produttori",
          queryString: '',
          componentType: 'grid',
          enableEditor: {
            add: true,
            remove: false,
            update: true
          },
          buttonOption: {
            text: 'Zone',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Cliente',
            name: 'cliente',
            location: 'after',
          },


        }
      },
      { type: 'empty', dataField: '', dataType: '' },
      { type: 'empty', dataField: '', dataType: '' },

      { type: 'empty', caption: ' ', dataField: '', dataType: '', colSpan: '4' },
      /**Produttore**/
      {
        type: 'campoSpecial',
        colVisible: false,
        dataField: "idProduttore",
        caption: "Produttore",
        class: 'd-none',
        colSpan: '4',
        dynamic: {
          valueExpr: '',
          queryString: '',
          displayExpr: 'id',
          dataSource: 'Sede',
          autocomplete: false,




        }

      },
      {
        type: 'campoSpecial', dataField: "produttore_Descrizione_Full", dataType: "", caption: "Prod./Detent.",
        colVisible: false,
        disableOnUpdate: false,
        width: '27vw',
        nCol: '9',
        class: 'disabled-soggetti',
        placeHolder: 'Digita la ragione sociale o il nome dell\'unità locale di produzione',
        validation: [
          { type: 'required', message: 'Produttore obbligatorio' }
        ],
        dynamic: {
          dataSource: "SoggettoSede/GetAllSoggettiAndSedi",
          service: 'soggetto',
          autocomplete: true,
          valueExpr: '',
          displayExpr: ['descrizioneSoggetto', 'descrizione'],
          related: ['id|idProduttore', 'numeroIscrizioneAlbo|autorizzazioneProduttore_Numero'],
          costantValue: [
            {
              key: 'NostreAziende',
              value: 'N'
            },
            {
              key: 'TipoAttivita',
              value: 'P'
            },
            {
              key: 'descrizioneSoggetto',
              value: 'produttore_Descrizione_Soggetto'
            },
            {
              key: 'descrizioneSede',
              value: 'produttore_Descrizione_Sede'
            }

          ],
          componentType: 'AnaSoggettoComponent',
          searchExpr: {
            expand: 'Sede',
            headerField: 'RagioneSociale',
            valueExpr: 'Id',
            dataFields: ['DescrizioneSoggetto', 'Descrizione'],
            related: ['Id|idProduttore', 'numeroIscrizioneAlbo|autorizzazioneProduttore_Numero'],
            optionalFilters: {
              IsProduttore: true,
              NsAzienda: false
            },
          },
          buttonOption: {
            text: 'Soggetto',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Produttori',
            name: 'soggetto',
            location: 'after',
          },



        }
      },
      {
        type: 'campo', caption: 'Detentore',
        labelVisible: true,
        labelColon: false,
        colVisible: false,
        editorType: 'dxCheckBox',
        class: 'label-auto',
        dataField: 'isDetentore',
        dataType: 'boolean',
        trueText: 'Si',
        falseText: 'No',
        showEditorAlways: false,
        nCol: '2',
      },
      {
        type: 'simpleButton', colVisible: false,
        dataField: "addElencoProduttori",
        nCol: 'auto',
        dataType: "",
        caption: "addElencoProduttori",
        editorClass: 'nica-plaintext-readonly',
        class: 'blueButton',
        button: {
          text: '',
          name: 'addElencoProduttori',
          location: 'after',
          disabled: true,
          event: "addDati",
          hint: "mostra e gestisci l'elenco dei produttori e microraccolta",
          icon: "glyphicon mdi mdi-dots-horizontal",
          outPutValue: false,


        }
      },
      { type: 'empty', dataField: '', dataType: '', },


      /***Autorizzazione Produttore ***/

      /* {
        type: 'campoSpecial',
        colVisible: false, dataField: "autorizzazioneProduttoreAlbo_Full",
        caption: "N.Iscriz.Albo",
        hideOnEdit: true,
 
        dynamic: {
          valueExpr: '',
          queryString: '?id=$idProduttore',
          displayExpr: ['numeroIscrizioneAlbo', 'dataIscrizioneAlbo'],
          searchExpr: 'numeroIscrizioneAlbo',
          dataSource: 'sede',
          autocomplete: true,
 
 
        }
      },
 */

      {
        type: 'campoSpecial', dataField: "autorizzazioneProduttore_Descrizione_Full",
        dataType: "",
        caption: "Autorizz.",
        colVisible: false,
        nCol: '5',
        width: '15vw',
        placeHolder: 'Digita in numero dell\'autorizzazione',
        dynamic: {

          queryString: "/$idProduttore",
          filterStatic: "",
          displayExpr: ['numero', 'dataRilascio'],
          dataSource: "Autorizzazione",
          service: "autorizzazione",
          searchExpr: {
            fatherDataField: 'produttore_Descrizione_Full',
            //expand: 'Sede',
            //headerField: 'RagioneSociale',
            valueExpr: 'id',
            dataFields: ['numero', 'dataRilascio'],
            related: ['id|idAutorizzazioneProduttore'],
            optionalFilters: {
              //isAutista: true,
              //NsAzienda: true
            },
          },
          autocomplete: true,
          valueExpr: '',

          related: ['id|idAutorizzazioneProduttore', 'numeroIscrizioneAlbo|produttoreNumeroIscrizioneAlbo'],
          costantValue: [
            {
              key: 'idSede',
              value: 'idProduttore'
            },
            {
              key: 'descrizioneSoggetto',
              value: 'produttore_Descrizione_Soggetto'
            },
            {
              key: 'descrizioneSede',
              value: 'produttore_Descrizione_Sede'
            }

          ],
          componentType: 'AnaAutorizzazioneComponent',
          buttonOption: {
            text: 'Autorizzazione',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia la lista delle autorizzazioni del soggetto selezionato',
            name: 'autorizzazione',
            location: 'after',

          },

        }
      },
      /* {
        type: 'campo', dataField: "autorizzazioneProduttoreAlbo_Full",
        dataType: "",
        readonly:true,
        caption: "N.Iscriz.Albo",
        colVisible: false,
        width: '15vw',
      
        
      }, */
      //CategoriaAlboProduttore idProduttoreAlboCategoria
      {
        type: 'campoSpecial',
        colVisible: false, dataField: "idAutorizzazioneProduttore",
        caption: "Autorizz.",
        class: 'd-none',
        disableOnUpdate: true,
        dynamic: {
          valueExpr: '',
          queryString: '',

          displayExpr: 'id',
          dataSource: 'Autorizzazione?id=',
          autocomplete: false,
          related: ['descrizione|autorizzazioneProduttore_Descrizione_Full']
        }

      },
      {
        type: 'campoSpecial', colVisible: false, dataField: "idProduttoreAlboCategoria",
        class: 'd-none',
        dynamic: {
          valueExpr: '',
          displayExpr: 'id',
          dataSource: 'AlboCategoria',
          autocomplete: false,


        }

      },
      {
        type: 'campoSpecial', colVisible: false, dataField: "produttoreAlboCategoria_Descrizione_Full",
        width: '13.7vw',
        caption: "N.iscrz.Albo",
        disableOnUpdate: true,
        class: 'label-soggetti',
        nCol: '5',
        dynamic: {
          costantValue: [
            {
              key: 'idSede',
              value: 'idProduttore'
            },
            {
              key: 'descrizioneSoggetto',
              value: 'produttore_Descrizione_Soggetto'
            },
            {
              key: 'descrizioneSede',
              value: 'produttore_Descrizione_Sede'
            }

          ],
          valueExpr: '',
          queryString: '/$idProduttore',
          displayExpr: 'id',
          dataSource: 'AlboCategoria',
          service: 'AlboCategoria',
          autocomplete: false,
          componentType: 'AnaAlboComponent',
          related: ['id|idProduttoreAlboCategoria', 'dataInizio|dataInizioCategoriaAlboGestoreProd', 'idCategoriaAlboGestore|idCategoriaAlboGestoreP'],
          buttonOption: {
            text: 'Albo',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Lista iscrizione albo del trasportatore selezionato',
            name: 'albo',
            location: 'after',
          },

        }

      },
      /* {
        type: 'campoSpecial', colVisible: false, dataField: "categoriaAlboGestoreProd",
        editorType: 'dxSelectBox', class: 'd-none',
        colSpan: '4',
        lista: {
          valueExpr: 'id',
          displayExpr: 'descrizione',
          dataSource: 'CategoriaAlboGestore',
 
        }
 
      }, */

      {
        type: 'campoSpecial', colVisible: false, dataField: "idCantiereFuoriUl",
        colSpan: '4',
        class: 'd-none',
        hideOnEdit: false,
        caption: "Cantiere",


      },

      {
        type: 'campoSpecial', dataField: "cantiere_Descrizione", dataType: "", caption: "Cantiere",
        width: '15vw',
        colSpan: '4',
        colVisible: false,
        labelVisible: true,
        hideOnEdit: false,
        disableOnUpdate: true,
        editorClass: 'text-uppercase',
        class: '',
        nCol: '5',
        dynamic: {
          costantValue: [
            {
              key: 'idSede',
              value: 'idProduttore'
            },
            {
              key: 'descrizioneSoggetto',
              value: 'produttore_Descrizione_Soggetto'
            },
            {
              key: 'descrizioneSede',
              value: 'produttore_Descrizione_Sede'
            }

          ],
          componentType: 'AnaUnitaLocaliComponent',
          queryString: "/$idProduttore",
          filterStatic: "?$filter=(isSospeso ne true)",
          displayExpr: ['descrizione', 'indirizzo', 'comune'],
          dataSource: "Cantiere",
          service: 'cantiere',
          autocomplete: true,
          searchExpr: 'descrizione',
          valueExpr: '',
          caption: "Lista Cantieri fuiri unità locale",

          related: ['id|idCantiereFuoriUl'],

          buttonOption: {
            text: 'CantiereFuoriUl',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia la lista dei fuori unità locale del soggetto selezionato',
            name: 'CantiereFuoriUl',
            location: 'after',

          },

        }
      },




      {
        type: 'campoSpecial', dataField: "magazzinoProduttore_Descrizione", dataType: "", caption: "Magaz.Scarico",
        colVisible: false,
        labelVisible: true,
        hideOnEdit: false,
        colSpan: '4',
        width: '33.5vw',
        placeHolder: 'Digita il nome del magazzino..',
        dynamic: {
          costantValue: [

            { key: 'idSede', value: 'idProduttore' }
          ],

          related: ['id|idMagazzinoProduttore'],
          queryString: "?idSede=$idProduttore",
          filterStatic: "",
          displayExpr: 'descrizione',
          dataSource: "MagazzinoRifiuti",
          service: 'magazzinorifiuti',
          autocomplete: true,
          searchExpr: {
            fatherDataField: 'destinatario_Descrizione_Full',
            headerField: '',
            valueExpr: 'descrizione',
            dataFields: ['descrizione'],
            related: ['id|idMagazzinoProduttore']

          },
          valueExpr: '',
          caption: "Lista Magazzini produttore",
          componentType: 'dynamicGrid',
          buttonOption: {
            text: 'magazzinoProduttore',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia la lista magazzinoi del soggetto selezionato',
            name: 'magazzinoProduttore',
            location: 'after',

          },
          settingGrid: createGridConfig({
            // qui puoi sovrascrivere le proprietà di default o aggiungerne di nuove
            mode: null,
            allowUpdating: true,
            allowDeleting: true,
            height: 630,
            colonne: [
              {
                dataField: 'descrizione',
                dataType: '',
                caption: 'Descrizione',
                allowEditing: true,
              },
            ],

          }),
        }
      },

      {
        type: 'campoSpecial', colVisible: false, dataField: "caricoAutomatico_IdMagazzino",
        colSpan: '4',
        class: 'd-none',
        hideOnEdit: false,
        caption: "",


      },


      { type: 'empty', dataField: '', caption: ' ', colSpan: '4' },
      {
        type: 'campoDesc', dataField: 'trasportoDesc', defaultValue: 'Nessun trasporto', colSpan: '4',
        labelVisible: false, nCol: '10'
      },

      {
        type: 'campoSpecial', dataField: "trasportatore_Descrizione_Full", dataType: "", caption: "Trasportatore",
        nCol: '9',
        colVisible: false,
        costantValue: [
          { key: 'idSede', value: 'idTrasportatore' }
        ],
        labelVisible: true,
        editorClass: 'trasportatore-desc',
        class: 'disabled-soggetti',
        width: '32vw',
        dynamic: {
          dataSource: "SoggettoSede/GetAllSoggettiAndSedi",
          service: 'soggetto',
          autocomplete: true,
          valueExpr: '',
          related: ['id|idTrasportatore', 'dataIscrizioneAlbo|dataIscrizioneAlboT', 'numeroIscrizioneAlbo|trasportatore_NumDataIscrizioneAlbo'],
          displayExpr: ['descrizioneSoggetto', 'descrizione'],
          searchExpr: {
            expand: 'Sede',
            headerField: 'RagioneSociale',
            valueExpr: 'Id',
            dataFields: ['DescrizioneSoggetto', 'Descrizione'],
            related: ['id|idTrasportatore', 'dataIscrizioneAlbo|dataIscrizioneAlboT', 'numeroIscrizioneAlbo|numeroIscrizioneAlboT'],
            optionalFilters: {
              IsTrasportatore: true,
              NsAzienda: false
            },
          },
          costantValue: [
            {
              key: 'NostreAziende',
              value: 'N'
            },
            {
              key: 'TipoAttivita',
              value: 'T'
            },
            {
              key: 'descrizioneSoggetto',
              value: 'trasportatore_Descrizione_Soggetto'
            },
            {
              key: 'descrizioneSede',
              value: 'trasportatore_Descrizione_Sede'
            }

          ],
          componentType: 'AnaSoggettoComponent',

          buttonOption: {
            text: 'Soggetto',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Trasportatori',
            name: 'soggetto',
            location: 'after',
          },



        }
      },

      {
        type: 'simpleButton', colVisible: false,
        dataField: "addElencoVettori",
        dataType: "",

        nCol: '1',
        caption: "addElencoVettori",
        editorClass: 'nica-plaintext-readonly',
        class: 'blueButton',
        button: {
          text: '',
          name: 'addElencoVettori',
          location: 'after',

          event: "addDati",
          hint: "Mostra e gestisci l'elenco dei vettori",
          icon: "glyphicon mdi mdi-dots-horizontal",
          outPutValue: false,


        }
      },

      { type: 'empty', dataField: '', },
      { type: 'empty', dataField: '', },

      {
        type: 'campoSpecial', colVisible: false, dataField: "idTrasportatore",
        class: 'd-none',
        nCol: '1',
        colSpan: '4',
        caption: "Trasportatore",
        disableOnUpdate: false,
        editorType: '',
        dynamic: {
          valueExpr: '',
          queryString: '',
          displayExpr: 'id',
          dataSource: 'Sede',

          autocomplete: false

        }

      },


      /**Albo e Categoria Albo**/


      {
        type: 'campoSpecial', colVisible: false, dataField: "idTrasportatoreAlboCategoria",
        class: 'd-none',
        colSpan: '4',
        dynamic: {
          valueExpr: 'id',
          displayExpr: '',
          dataSource: 'AlboCategoria',
          autocomplete: false,


        }

      },
      {
        type: 'campoSpecial', colVisible: false, dataField: "autorizzazioneTrasportatoreAlbo_Full",
        width: '14vw',
        caption: "N.iscrz.Albo",
        disableOnUpdate: true,
        colSpan: '4',
        nCol: '5',
        dynamic: {

          valueExpr: '',

          queryString: '/$idTrasportatore',
          displayExpr: 'id',
          dataSource: 'AlboCategoria',
          service: 'AlboCategoria',
          autocomplete: false,

          caption: "Lista categoria albo del trasportatore selezionato",
          costantValue: [
            {
              key: 'idSede',
              value: 'idTrasportatore'
            },
            {
              key: 'descrizioneSoggetto',
              value: 'trasportatore_Descrizione_Soggetto'
            },
            {
              key: 'descrizioneSede',
              value: 'trasportatore_Descrizione_Sede'
            }

          ],
          componentType: 'AnaAlboComponent',

          related: ['id|idTrasportatoreAlboCategoria', 'dataInizio|dataInizioCategoriaAlboGestoreTras', 'idCategoriaAlboGestore|idCategoriaAlboGestoreT'],
          buttonOption: {
            text: 'Albo',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Lista iscrizione albo del trasportatore selezionato',
            name: 'albo',
            location: 'after',
          },

        }

      },


      /**Autista***/

      {
        type: 'campoSpecial', dataField: "autista_Cognome_Nome", dataType: "", caption: "Autista",
        width: '13.4vw',
        colVisible: false,
        nCol: '6',
        labelVisible: true,
        maxLength: "50",
        dynamic: {

          dataSource: 'Autista',
          service: 'autista',
          autocomplete: true,
          searchExpr: {
            fatherDataField: 'trasportatore_Descrizione_Full',

            //expand: 'Sede',
            //headerField: 'RagioneSociale',
            valueExpr: 'id',
            dataFields: ['nome', 'cognome'],
            related: ['id|idAutista'],
            optionalFilters: {
              isAutista: true,
              //NsAzienda: true
            },
          },
          valueExpr: '',
          displayExpr: ['nome', 'cognome'],
          caption: "Lista Autisti",
          queryString: '/$idTrasportatore',
          filterStatic: '?$filter=(isautista eq true)',
          costantValue: [
            {
              key: 'idSede',
              value: 'idTrasportatore'
            },

            {
              key: 'descrizioneSoggetto',
              value: 'trasportatore_Descrizione_Soggetto'
            },
            {
              key: 'descrizioneSede',
              value: 'trasportatore_Descrizione_Sede'
            }

          ],
          componentType: 'AnaUnitaLocaliComponent',
          related: ['id|idAutista'],

          buttonOption: {
            text: 'Autista',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Autista',
            name: 'Autista',
            location: 'after',
          },

        }
      },


      {
        type: 'campoSpecial',
        dataField: "descrizione_Operatore_1",
        colVisible: false,
        dataType: "",
        caption: "Oper.1",
        colWidth: '100',
        nCol: '3',
        width: '7vw',
        disableOnUpdate: true,
        dynamic: {

          valueExpr: '',
          queryString: '/$idTrasportatore',
          filterStatic: '?$filter=(isoperaio eq true)',
          searchExpr: {
            fatherDataField: '',
            valueExpr: 'id',
            dataFields: ['nome', 'cognome'],
            related: ['id|idOperatore1'],
            optionalFilters: {
              isOperatore: true,

            },
          },
          displayExpr: 'cognome',
          dataSource: 'Autista',
          service: 'autista',
          related: ['id|idOperatore1'],
          autocomplete: false,
          costantValue: [
            {
              key: 'idSede',
              value: 'idTrasportatore'
            },

            {
              key: 'descrizioneSoggetto',
              value: 'trasportatore_Descrizione_Soggetto'
            },
            {
              key: 'descrizioneSede',
              value: 'trasportatore_Descrizione_Sede'
            }

          ],
          componentType: 'AnaUnitaLocaliComponent',
          buttonOption: {
            text: 'Operatore',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Operatori',
            name: 'Operatori',
            location: 'after',
          },

        }
      },

      {
        type: 'campoSpecial',
        dataField: "descrizione_Operatore_2",
        colVisible: false,
        dataType: "",
        caption: "Oper.2",
        colWidth: '100',
        width: '7vw',
        nCol: '3',
        disableOnUpdate: true,
        dynamic: {

          valueExpr: '',
          queryString: '/$idTrasportatore',
          filterStatic: '?$filter=(isoperaio eq true)',
          searchExpr: {
            fatherDataField: '',
            valueExpr: 'id',
            dataFields: ['nome', 'cognome'],
            related: ['id|idOperatore2'],
            optionalFilters: {
              isOperatore: true,

            },
          },
          displayExpr: 'cognome',
          dataSource: 'Autista',
          service: 'autista',
          related: ['id|idOperatore2'],
          autocomplete: false,
          costantValue: [
            {
              key: 'idSede',
              value: 'idTrasportatore'
            },

            {
              key: 'descrizioneSoggetto',
              value: 'trasportatore_Descrizione_Soggetto'
            },
            {
              key: 'descrizioneSede',
              value: 'trasportatore_Descrizione_Sede'
            }

          ],
          componentType: 'AnaUnitaLocaliComponent',
          buttonOption: {
            text: 'Operatore',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Operatori',
            name: 'Operatori',
            location: 'after',
          },

        }
      },
      { type: 'empty', dataField: '', },

      {
        type: 'campoSpecial', colVisible: false, dataField: "automezzo_Descrizione_Full",
        caption: "Motrice",
        width: '15vw',
        maxLength: '11',
        nCol: '6',
        dynamic: {

          valueExpr: '',
          queryString: '/$idTrasportatore',
          filterStatic: "?$filter=( tipoautomezzo ne 'D' )",
          displayExpr: ['descrizione', 'targa'],
          dataSource: 'Automezzo',
          service: 'automezzo',
          autocomplete: true,
          searchExpr: {
            //expand: 'Sede',
            fatherDataField: 'trasportatore_Descrizione_Full',

            //headerField: 'RagioneSociale',
            valueExpr: 'id',
            dataFields: ['targa'],
            related: ['id|idAutomezzo', 'isScarrabile|isScarrabileMostrice'],
            optionalFilters: {
              //tipoautomezzo: 'D'
              //NsAzienda: true
            },
          },
          costantValue: [
            {
              key: 'idSede',
              value: 'idTrasportatore'
            },
            {
              key: 'descrizioneSoggetto',
              value: 'trasportatore_Descrizione_Soggetto'
            },
            {
              key: 'descrizioneSede',
              value: 'trasportatore_Descrizione_Sede'
            }

          ],
          componentType: 'AnaAutomezzoComponent',
          related: ['id|idAutomezzo', 'isScarrabile|isScarrabileMostrice'],
          buttonOption: {
            text: 'Automezzo',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Automezzi',
            name: 'Automezzo',
            location: 'after',
          },

        }

      },

      {
        type: 'campoDesc', dataField: 'carrozzeriemobiliautomezzo', labelVisible: false, nCol: '6',

        /* dynamic:{
          dataSource:'CategoriaAutomezzo',
          service:'',
          queryString:'?$idAutomezzo',
          autocomplete:false,
          displayExpr:'listaCarrozzeriaAlboGeneric',
          valueExpr:'',
 
        } */
      },
      { type: 'empty', dataField: '', },
      { type: 'empty', dataField: '', },

      {
        type: 'campoSpecial', dataField: "rimorchio_Descrizione", dataType: "", caption: "Rimorchio",
        width: '15vw',
        nCol: '6',
        colVisible: false,
        labelVisible: true,
        class: 'rimorchio',
        dynamic: {

          dataSource: 'Automezzo',
          autocomplete: true,
          valueExpr: '',
          displayExpr: ['descrizione', 'targa'],
          service: 'automezzo',
          caption: "Lista Automezzi",
          queryString: '/$idTrasportatore',
          filterStatic: "?$filter=( tipoautomezzo eq 'D' )",
          related: ['id|idRimorchio'],
          searchExpr: {
            //expand: 'Sede',
            fatherDataField: 'trasportatore_Descrizione_Full',

            //headerField: 'RagioneSociale',
            valueExpr: 'id',
            dataFields: ['targa'],
            related: ['id|idRimorchio'],
            optionalFilters: {
              //tipoautomezzo: 'D'
              //NsAzienda: true
            },
          },
          costantValue: [
            {
              key: 'idSede',
              value: 'idTrasportatore'
            },
            {
              key: 'descrizioneSoggetto',
              value: 'trasportatore_Descrizione_Soggetto'
            },
            {
              key: 'descrizioneSede',
              value: 'trasportatore_Descrizione_Sede'
            }

          ],
          componentType: 'AnaAutomezzoComponent',
          buttonOption: {
            text: 'rimorchio',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Rimorchio Automezzo',
            name: 'Rimorchio',
            location: 'after',
          },


        }
      },
      { type: 'campoDesc', dataField: 'carrozzerieMobiliRimorchio', labelVisible: false, nCol: '6', },
      { type: 'empty', dataField: '', },
      { type: 'empty', dataField: '', },
      {
        type: 'campoSpecial', colVisible: false, dataField: "idAutista",
        colSpan: '4',
        labelVisible: false,
        class: 'd-none',
        nCol: '0',
        caption: "idAutista",

        dynamic: {
          valueExpr: '',
          queryString: '',
          displayExpr: 'id',
          dataSource: 'Autista?id=',

          autocomplete: false,
          checkValue: {
            checkValueMessage: '',
            forceInsert: false
          },
          related: ['nome,cognome,matricola|autista_Descrizione_Full'],

        }

      },
      {
        type: 'campoSpecial', colVisible: false, dataField: "idAutomezzo",
        caption: "Automezzo",
        class: 'd-none',
        colSpan: '4',
        dynamic: {

          valueExpr: '',
          queryString: 'id',
          dataSource: '',
          displayExpr: 'id',
          autocomplete: false,


        }

      },

      {
        type: 'campoSpecial', dataField: "idRimorchio", dataType: "", caption: "Rimorchio",
        colSpan: '4',
        colVisible: false,
        labelVisible: true,
        class: 'd-none',
        dynamic: {
          dataSource: 'Automezzo?id=',
          autocomplete: false,
          checkValue: {
            checkValueMessage: '',
            forceInsert: false
          },
          valueExpr: '',
          displayExpr: 'id',
          queryString: '',
          filterStatic: "?$filter=( tipoautomezzo eq 'D' )",
          componentType: 'grid',
          related: ['targa|rimorchio_Targa'], //


        }
      },


      { type: 'empty', caption: ' ', colSpan: '4', dataField: '', dataType: '' },

      /**Destinatario**/
      {
        type: 'campoSpecial', colVisible: false, dataField: "idDestinatario",
        editorType: 'dxSelectBox',
        class: 'd-none',
        colSpan: '4',
        caption: "Destinatario",
        disableOnUpdate: true,


      },
      {
        type: 'campoSpecial', dataField: "destinatario_Descrizione_Full", dataType: "", caption: "Destinatario",
        colSpan: '4',
        nCol: '10',
        width: '33.5vw',
        colVisible: false,
        labelVisible: true,
        editorClass: 'destinatario-desc',
        class: 'disabled-soggetti',
        validation: [{ type: 'required', message: 'Destinatario obbligatorio' }],

        dynamic: {
          autocomplete: true,
          dataSource: "SoggettoSede/GetAllSoggettiAndSedi",
          service: 'soggetto',
          valueExpr: '',
          displayExpr: ['descrizioneSoggetto', 'descrizione'],
          related: ['id|idDestinatario'],
          searchExpr: {
            expand: 'Sede',
            headerField: 'RagioneSociale',
            valueExpr: 'Id',
            dataFields: ['DescrizioneSoggetto', 'Descrizione'],
            related: ['Id|idDestinatario'],
            optionalFilters: {
              IsSmaltitore: true,
              NsAzienda: false
            },
          },
          costantValue: [
            {
              key: 'NostreAziende',
              value: 'N'
            },
            {
              key: 'TipoAttivita',
              value: 'S'
            },
            {
              key: 'descrizioneSoggetto',
              value: 'destinatario_Descrizione_Soggetto'
            },
            {
              key: 'descrizioneSede',
              value: 'destinatario_Descrizione_Sede'
            }

          ],
          componentType: 'AnaSoggettoComponent',
          buttonOption: {
            text: 'Soggetto',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Destinatari',
            name: 'soggetto',
            location: 'after',
          },


        }
      },



      {
        type: 'campoSpecial', dataField: "autorizzazioneDestinatario_Descrizione_Full",
        dataType: "",
        caption: "Autorizz.",
        colVisible: false,
        width: '15vw',
        nCol: '5',
        placeHolder: 'Digita il Numero dell\'autorizzazione',
        dynamic: {
          costantValue: [
            {
              key: 'idSede',
              value: 'idDestinatario'
            },
            {
              key: 'descrizioneSoggetto',
              value: 'destinatario_Descrizione_Soggetto'
            },
            {
              key: 'descrizioneSede',
              value: 'destinatario_Descrizione_Sede'
            }

          ],
          componentType: 'AnaAutorizzazioneComponent',
          queryString: "/$idDestinatario",
          filterStatic: "",
          searchExpr: {
            //expand: 'Sede',
            //headerField: 'RagioneSociale',
            fatherDataField: 'destinatario_Descrizione_Full',
            valueExpr: 'id',
            dataFields: ['numero'],
            related: ['id|idAutorizzazioneDestinatario'],
            optionalFilters: {
              //isAutista: true,
              //NsAzienda: true
            },
          },
          dataSource: "Autorizzazione",
          service: 'autorizzazione',
          displayExpr: ['numero', 'dataRilascio'],
          autocomplete: true,
          valueExpr: '',

          related: ['id|idAutorizzazioneDestinatario'],

          buttonOption: {
            text: 'Autorizzazione',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia la lista delle autorizzazioni del soggetto selezionato',
            name: 'autorizzazione',
            location: 'after',

          },

        }
      },
      {
        type: 'campoSpecial',
        colVisible: false, dataField: "idAutorizzazioneDestinatario",
        caption: "Autorizz.",
        class: 'd-none',
        disableOnUpdate: true,
        dynamic: {
          valueExpr: '',
          queryString: '',

          displayExpr: 'id',
          dataSource: 'Autorizzazione?id=',
          autocomplete: false,

          caption: "Lista Autorizzazioni",
          componentType: 'grid',



        }

      },
      {/***Autorizzazione Area destinatario ***/
        type: 'campoSpecial', colVisible: false, dataField: "idAutorizzazioneDestinatarioArea",
        class: 'd-none',
        caption: "Autorizz.Area",
        disableOnUpdate: true,
        dynamic: {
          valueExpr: 'id',
          queryString: '',
          displayExpr: 'descrizioneArea',
          dataSource: 'AutorizzazioneArea',
          autocomplete: false,
          related: ['descrizioneArea|autorizzazioneDestinatarioArea_Full'],
          caption: "Lista Autorizzazioni",
          componentType: 'grid',


        }

      },
      {
        type: 'campoSpecial', dataField: "autorizzazioneDestinatarioArea_Full", dataType: "", caption: "Area",
        nCol: '5',
        width: '13.7vw',
        colVisible: false,
        labelVisible: true,
        class: 'label-soggetti',
        placeHolder: 'Digita il nome dell\'area autorizzata',
        dynamic: {

          costantValue: [
            {
              key: 'idSede',
              value: 'idDestinatario'
            },
            { key: 'idAutorizzazione', value: 'idAutorizzazioneDestinatario' },

            {
              key: 'descrizioneSoggetto',
              value: 'destinatario_Descrizione_Soggetto'
            },
            {
              key: 'descrizioneSede',
              value: 'destinatario_Descrizione_Sede'
            }

          ],
          componentType: 'AnaAutorizzazioneComponent',
          queryString: '?idAutorizzazione=$idAutorizzazioneDestinatario',
          displayExpr: 'descrizioneArea',
          dataSource: 'AutorizzazioneArea',
          service: 'autorizzazionearea',
          autocomplete: true,
          searchExpr: {
            //expand: 'Sede',
            fatherDataField: 'destinatario_Descrizione_Full',

            //headerField: 'RagioneSociale',
            valueExpr: 'id',
            dataFields: ['descrizioneArea'],
            related: ['id|idAutorizzazioneDestinatarioArea'],
            optionalFilters: {
              //isAutista: true,
              //NsAzienda: true
            },
          },
          valueExpr: '',
          caption: "Lista delle aree autorizzate",

          related: ['id|idAutorizzazioneDestinatarioArea'],

          buttonOption: {
            text: 'AutorizzazioneArea',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia la lista delle aree autorizzate',
            name: 'AutorizzazioneArea',
            location: 'after',
          },


        }
      },

      {
        type: 'campoSpecial', dataField: 'idOperazioneRD', dataType: '', caption: 'Op.smalt/recup.',
        colVisible: false,
        width: '7.3vw',
        nCol: '5',
        orderGriglia: 10,
        colWidth: 112,
        editorClass: 'text-uppercase',
        validation: [
          { type: 'required', message: 'Op.smaltim./recup. obbligatoria' }
        ],

        dynamic: {
          displayExpr: '',
          dataSource: 'OperazioneSmaltimento',
          service: 'generic',
          autocomplete: false,
          checkValue: {
            checkValueMessage: '',
            forceInsert: false
          },
          valueExpr: 'id',
          caption: "Lista Modalità di smaltimento",
          componentType: 'dynamicGrid',

          buttonOption: {
            text: 'OperazioneRD',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: "'Sfoglia l'elenco delle operazioni di smaltimento",
            name: 'OperazioneRD',
            location: 'after',
          },
          settingGrid: createGridConfig({
            // qui puoi sovrascrivere le proprietà di default o aggiungerne di nuove
            mode: null,
            height: 630,
           

          }),
		  
        }
      },
      {
        type: 'campoSpecial', dataField: "magazzinoDestinatario_Descrizione", dataType: "", caption: "Magazzino",
        width: '13.7vw',
        nCol: '5',
        colVisible: false,
        labelVisible: true,
        class: 'label-magazzino label-disabled',
        placeHolder: 'Digita il nome del magazzino..',
        dynamic: {

          queryString: "?idSede=$idDestinatario",
          filterStatic: "",
          displayExpr: 'descrizione',
          dataSource: "MagazzinoRifiuti",
          service: 'magazzinorifiuti',
          autocomplete: true,
          valueExpr: '',
          caption: "Lista Magazzini unità locale",

          related: ['id|idMagazzinoDestinatario'],
          searchExpr: {

            fatherDataField: 'destinatario_Descrizione_Full',
            valueExpr: 'id',
            dataFields: ['descrizione'],
            related: ['id|idMagazzinoDestinatario'],
            optionalFilters: {
              //IsTrasportatore: true,
              //NsAzienda: false
            },
          },
          buttonOption: {
            text: 'magazzinoDestinatario',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia la lista magazzinoi del soggetto selezionato',
            name: 'magazzinoDestinatario',
            location: 'after',

          },
          costantValue: [
            {
              key: 'idSede',
              value: 'idDestinatario'
            },
            {
              key: 'descrizioneSoggetto',
              value: 'destinatario_Descrizione_Soggetto'
            },
            {
              key: 'descrizioneSede',
              value: 'destinatario_Descrizione_Sede'
            }

          ],
          componentType: 'AnaUnitaLocaliComponent',
        }
      },
      {
        type: 'campoSpecial', colVisible: false, dataField: "idMagazzinoDestinatario",
        hideOnEdit: false,
        class: 'd-none',

        caption: "Magazzino.",
        dynamic: {
          costantValue: [{
            key: 'idSede',
            value: 'idDestinatario'
          }],
          valueExpr: '',
          queryString: '',
          displayExpr: 'id',
          dataSource: 'MagazzinoRifiuti',
          autocomplete: false,
          //related:['descrizione|magazzinoDestinatario_Descrizione']


        }

      },

      { type: 'empty', dataField: '', dataType: '', caption: '' },

      { type: 'empty', colSpan: '4', dataField: '', dataType: '', caption: ' ' },

      /**Intermediario**/

      {
        type: 'campo', colVisible: false, dataField: "idIntermediario",
        editorType: '',
        class: 'd-none',
        colSpan: '4',
        caption: "",
        disableOnUpdate: true,


      },

      {
        type: 'campoSpecial', dataField: "intermediario_Descrizione_Full", dataType: "", caption: "Intermediario",
        width: '32vw',
        nCol: '9',
        colVisible: false,
        labelVisible: true,
        editorClass: 'destinatario-desc',
        class: 'disabled-soggetti',
        dynamic: {
          caption: "Lista Intermediario",
          autocomplete: true,
          dataSource: 'SoggettoSede/GetAllSoggettiAndSedi',
          service: 'soggetto',
          valueExpr: '',
          displayExpr: ['descrizioneSoggetto', 'descrizione'],
          related: ['id|idIntermediario', 'numeroIscrizioneAlbo|autorizzazioneIntermediarioAlbo', 'dataIscrizioneAlbo|dataIscrizioneAlboI'],
          searchExpr: {
            expand: 'Sede',
            headerField: 'RagioneSociale',
            valueExpr: 'Id',
            dataFields: ['DescrizioneSoggetto', 'Descrizione'],
            related: ['Id|idIntermediario'],
            optionalFilters: {
              IsIntermediario: true,
              NsAzienda: false
            },
          },
          costantValue: [
            {
              key: 'NostreAziende',
              value: 'N'
            },
            {
              key: 'TipoAttivita',
              value: 'I'
            },
            {
              key: 'descrizioneSoggetto',
              value: 'destinatario_Descrizione_Soggetto'
            },
            {
              key: 'descrizioneSede',
              value: 'destinatario_Descrizione_Sede'
            }

          ],
          componentType: 'AnaSoggettoComponent',
          buttonOption: {
            text: 'Soggetto',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Intermediari',
            name: 'soggetto',
            location: 'after',
          },


        }
      },
      {
        type: 'simpleButton', colVisible: false,
        dataField: "addElencoIntermediari",
        dataType: "",
        nCol: '1',
        caption: "addElencoVettori",
        editorClass: 'nica-plaintext-readonly',
        class: 'blueButton',
        button: {
          text: '',
          name: 'addElencoIntermediari',
          location: 'after',

          event: "addDati",
          hint: "mostra e gestisci l'elenco dei vettori",
          icon: "glyphicon mdi mdi-dots-horizontal",
          outPutValue: false,


        }
      },
      { type: 'empty', dataField: '', dataType: '' },
      { type: 'empty', dataField: '', dataType: '' },

      /***Intermediario Albo ***/
      /*  {
         type: 'campo', dataField: "intermediario_NumDataIscrizioneAlbo", dataType: "", caption: "N.Iscriz.Albo",
         colVisible: false,
         labelVisible: true,
         width: '15vw',
         disableOnUpdate: true,
         readonly: true
 
       },
  */
      {
        type: 'campoSpecial', colVisible: false, dataField: "idIntermediarioCategoriaAlbo",
        class: 'd-none',
        colSpan: '4',
        dynamic: {
          valueExpr: '',
          displayExpr: 'id',
          dataSource: 'AlboCategoria',
          autocomplete: false,
          checkValue: {
            checkValueMessage: '',
            forceInsert: false
          },

        }

      },
      {
        type: 'campoSpecial', colVisible: false, dataField: "autorizzazioneIntermediarioAlbo_Full",
        width: '15vw',
        caption: "N.iscrz.Albo",
        colSpan: '4',
        nCol: '5',
        disableOnUpdate: true,
        dynamic: {
          costantValue: [{
            key: 'idSede',
            value: 'idIntermediario'
          }],
          valueExpr: '',
          queryString: '/$idIntermediario',
          displayExpr: 'id',
          dataSource: 'AlboCategoria',
          service: 'AlboCategoria',
          autocomplete: false,

          caption: "Lista categoria albo del intermediario selezionato",

          componentType: 'AnaAlboComponent',

          related: ['id|idIntermediarioAlboCategoria', 'dataInizio|dataIscrizioneAlboI', 'idCategoriaAlboGestore|idCategoriaAlboGestoreI'],
          buttonOption: {
            text: 'Albo',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Lista iscrizione albo del trasportatore selezionato',
            name: 'albo',
            location: 'after',

          },

        }

      },

      /* {
        type: 'campoSpecial', colVisible: false, dataField: "idIntermediarioCategoriaAlbo",
        editorType: 'dxSelectBox', class: 'd-none',
        colSpan: '4',
        lista: {
          valueExpr: 'id',
          displayExpr: 'descrizione',
          dataSource: 'CategoriaAlboGestore',
          related: ['descrizione|descCategoriaAlboItermediario']
        }
 
      }, */
    ]
  },



  {
    itemType: "group", caption: "", colCount: "5", class: 'dati-rifiuto ', groupDataField: 'dati-generali-movimento', data: [
      {
        type: 'campo', colVisible: false, dataField: "idLotto",
        class: 'd-none',
        colSpan: '5'
      },
      {
        type: 'campo', colVisible: false, dataField: "idLotto_Sede",
        class: 'd-none',
        colSpan: '5'
      },
      {
        type: 'campoSpecial', colVisible: true, dataField: "CER",
        colWidth: '66',
        orderGriglia: 11,
        nCol: '3',
        width: '9vw',
        maxLength: '6',
        caption: "CER",
        disableOnUpdate: false,
        showClearButton: true,
        dynamic: {
          valueExpr: 'id',
          queryString: '',
          displayExpr: '',
          dataSource: 'cer',
          service: 'cer',
          autocomplete: false,
          filterStatic: "?$filter=(not endswith(id,'00'))",
          caption: "Lista EER",
          componentType: 'dynamicGrid',
          related: ['pericoloso|isCerPericoloso', 'descrizione|descrizioneAssegnata'],

          buttonOption: {
            text: 'Cer',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia elenco dei rifiuti eer (F3)',
            name: 'eer',
            location: 'after',
          },
          settingGrid: createGridConfig({
            // qui puoi sovrascrivere le proprietà di default o aggiungerne di nuove
            mode: null,
            height: 630,
          }),
          buttons: [
            {

              class: 'badge',
              name: 'addSchedaTecnica',
              accesskey: 's',
              location: 'after',
              event: "SchedarifiutiComponent",
              text: '',
              hint: "Incolla dati dalla scheda descrittiva rifiuti",
              icon: "glyphicon icon-elenco-cer-trasp",
              outPutValue: false,
              visible: true
            },
            {
              name: 'GiacenzeRifiuti',
              icon: 'glyphicon icon-giacenze-magazzino',
              hint: 'Giacenze rifiuti',
              location: 'after',
              event: 'StatisticarifiutiComponent',
              visible: true


            },
          ]
        },
        validation: [
          { type: 'required', message: 'EER campo obbligatorio' }
        ],


      },
      
      {
        type: 'campo', dataField: "riferimentoEER", dataType: "", caption: "Rif.",
        /*  width: 4.3 + 'vw', */
        colWidth: '65',
        colVisible: true,
        labelVisible: true,
        nCol: '2',
        maxLength: '10',
        class: 'rif-cer',
        editorClass: 'text-uppercase',
        orderGriglia: 7,

      },
      {
        type: 'campoSpecial', dataField: "idStatoFisico", dataType: "", caption: "SF",
        width: 3 + 'vw',
        colWidth: '40',
        colVisible: false,
        labelVisible: true,
        nCol: '1',
        orderGriglia: 9,
        class: 'stato-fisico',
        showClearButton: false,
        maxLength: '2',
        validation: [
          { type: 'required', message: 'Stato fisico obbligatorio' }
        ],
        dynamic: {
          valueExpr: '',
          queryString: '',
          displayExpr: 'id',
          dataSource: 'StatoFisico',
          service: '',
          autocomplete: false,
          caption: "Lista Stati Fisici",
          componentType: 'dynamicGrid',
          buttonOption: {
            text: 'StatoFisico',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Lista StatoFisico',
            name: 'StatoFisico',
            location: 'after',
          },
          settingGrid: settingGridGeneric

        },
      },
      {
        type: 'campo', colVisible: true, caption:"Carico", dataField: "Carico",
      
        colSpan: '5'
      },
      {
        type: 'campo', colVisible: true, caption:"Scarico", dataField: "SCarico",
        colSpan: '5'
      },
      {
        type: 'campo', dataField: "isUrbano", dataType: "", caption: "Urbano",
        nCol: '2',
        colVisible: false,
        labelVisible: true,
        editorType: 'dxCheckBox',
        class: 'cer-urbano',
        defaultValue: false,
      },



      {
        type: 'campoSpecial', dataField: "lotto_Descrizione", caption: "Lotto di prod.",
        colVisible: false,
        labelVisible: true,
        width: '6.4vw',
        nCol: '3',
        disabled: true,
        showClearButton: true,
        dynamic: {
          valueExpr: '',
          displayExpr: 'numero',
          queryString: '/$idLotto_Sede',
          costantValue: [
            { key: 'idSede', value: 'idLotto_Sede' },
            {
              key: 'descrizioneSoggetto',
              value: 'produttore_Descrizione_Soggetto'
            },
            {
              key: 'descrizioneSede',
              value: 'produttore_Descrizione_Sede'
            }
          ],
          dataSource: 'lotto',
          service: 'lotto',
          autocomplete: false,
          popupWidth: '900',
          caption: "Lista Lotti",
          componentType: 'AnaUnitaLocaliComponent',
          related: ['id|idLotto'],
          buttonOption: {
            text: 'lotto',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Lista Lotti di produzione',
            name: 'LottoProduzione',
            location: 'after',
          },


        },
      },
      /*
      {
        type: 'campo', colVisible: false, dataField: "lotto_Descrizione", hideOnEdit: true,
        dataType: 'number',
        class: 'd-none',
        colSpan: '5'
      },
      */
      {
        type: 'campo',
        dataField: "descrizioneAssegnata",
        caption: "Desc.Assegnata",
        dataType: "",
        nCol: '10',
        colVisible: false,
        colSpan: '5',
        maxLength: '250'
      },

      {
        type: 'campoSpecial',
        dataField: "listaHP", caption: "Carat.Peric.",
        colVisible: false,
        orderGriglia: 12,
        colSpan: '5',
        colWidth: '110',
        nCol: '10',
        hideOnEdit: false,

        /*
        tagBoxList: {
          dataSource: 'Hp',
          displayExpr: 'id',
          valueExpr: 'id',
          maxDisplayedTags: 3,
          multiline: false,
          showSelectionControls: true,
        }
          */
        dynamic: {
          dataSource: 'Hp',
          autocomplete: false,
          displayExpr: '',
          valueExpr: 'id',
          caption: "Lista Caratteristiche di Pericolo",
          queryString: '',
          filter: '',
          componentType: 'dynamicGrid',
          buttonOption: {
            text: 'Lista Caratteristiche Pericolo',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Lista Caratteristiche Pericolo',
            name: 'stoccaggio',
            location: 'after',
          },
          settingGrid: createGridConfig({
            // qui puoi sovrascrivere le proprietà di default o aggiungerne di nuove
           
            selectionMode: 'multiple',
            height: 480,
            colonne: [
              {
                dataField: 'id',
                dataType: 'number',
                caption: 'Codice',
                width: 70,
                hideOnEdit: true,

              },

              {
                dataField: 'descrizione',
                dataType: '',
                caption: 'Descrizione',

                hideOnEdit: false
              },


            ]

          }),

        }
      },

      {
        type: 'campo',
        dataField: "caratteristicheChimiche",
        caption: "Carat.chim/fis.",
        dataType: "",
        width: '30.7vw',
        maxLength: '255',
        nCol: '9',
        colVisible: false,
      },
      {
        type: 'simpleButton', colVisible: false,
        dataField: "addDatiRifiuto",
        dataType: "",
        caption: "addDatiRifiuto",
        nCol: '1',
        editorClass: 'nica-plaintext-readonly',
        class: 'blueButton',
        button: {
          text: 'Altri dati relat.rifiuto',
          name: 'addDatiRifiuto',
          location: 'after',
          event: "addDati",
          hint: "Specifica altri dati relativi al rifiuto",
          icon: "glyphicon mdi mdi-open-in-new",
          outPutValue: false,


        }
      },
      { type: 'empty', dataField: "", dataType: "", caption: "" },
      { type: 'empty', dataField: "", dataType: "", caption: "" },
      { type: 'empty', dataField: "", dataType: "", caption: "" },

      {
        type: 'campo',
        dataField: "annotazioni",
        caption: "Annotazioni",
        dataType: "",
        colSpan: '5',
        nCol: '10',
        colVisible: false,
        maxLength: '255',

      },

      { type: 'empty', dataField: "", dataType: "", caption: " ", colSpan: '5' },

      {
        type: 'campo', dataField: "quantitaOrigineKg", dataType: "", caption: "Peso partenza",
        format: '########0.###',
        class: 'quantita-origine disabled-label-item',
        maxLength: "11",
        hideOnEdit: false,
        colVisible: false,
        labelVisible: true,
        editorType: 'dxNumberBox',
        disabled: true,
        readonly: true,
        nCol: '3'


      },
      {
        type: 'campo', dataField: "daVerificareADestino", dataType: "boolean", caption: "Verificato in partenza",

        colVisible: false,
        labelVisible: true,
        labelColon: false,
        labelPosition: 'right',
        hideOnEdit: false,
        labelWidth: 20,
        editorType: 'dxCheckBox',
        class: 'label-auto disabled-label-item',
        disabled: true,
        readonly: true,
        nCol: '3'
      },

      {
        type: 'campo', dataField: "volume", dataType: "", caption: "Volume ",
        format: '########0.###',
        maxLength: "11",
        colVisible: false,
        labelVisible: true,
        class: 'volume',
        editorType: 'dxNumberBox',
        nCol: '3'
      },
      {
        type: 'campoSpecial', dataField: "unitaMisuraVolume", dataType: "", caption: "MC/LT",
        colVisible: false,
        orderGriglia: 9,
        labelVisible: true,
        width: '3.8vw',
        class: 'volumeUm',
        maxLength: '1',
        nCol: '2',
        editorType: 'dxSelectBox',
        lista: {
          dataSource: 'umVolume',
          valueExpr: 'id',
          displayExpr: 'descrizione',
          placeholder: ' ',
          showClearButton: false,
          showDropDownButton: false,
          static: true,
        }
      },
      { type: 'empty', dataField: "", dataType: "", caption: "" },

      {
        type: 'campol', colVisible: false, dataField: "idTestoADR",
        caption: "ADR",
        dataType: '',
        class: 'd-none',
        colSpan: '5'
      },
      {
        type: 'campoSpecial', colVisible: false, dataField: "adr",
        caption: "ADR",
        disabled: true,
        readonly: true,
        width: '3vw',
        nCol: '2',
        editorType: 'dxSelectBox',

        lista: {
          dataSource: 'elaboraMUD',
          valueExpr: 'id',
          displayExpr: 'descrizione',
          showClearButton: false,
          showDropDownButton: false,
          placeholder: 'Si/No',
          static: true,

        }
      },

      {
        type: 'campoSpecial', colVisible: false, dataField: "testoADR_Descrizione",
        width: '14.9vw',
        caption: "Testo ADR",
        class: 'testo-adr',
        disabled: true,
        nCol: '3',
        dynamic: {
          costantValue: [
            { key: 'eer', value: 'eer' }
          ],
          valueExpr: '',

          autocomplete: false,
          displayExpr: 'testo',
          dataSource: 'TestiAdr',
          related: ['id|idTestoADR', 'idClasseAdr', 'idOnu|idONU'],
          queryString: '',
          service: 'testoAdr',
          caption: "Lista Testi ADR",
          componentType: 'dynamicGrid',
          buttonOption: {
            text: 'Onu',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Lista Onu',
            name: 'Onu',
            location: 'after',
          },
          settingGrid: settingTestiAdr
        }

      },
      {
        type: 'campoSpecial', colVisible: false, dataField: "idClasseAdr",
        width: '4.3vw',
        maxLength: '6',
        caption: "Classe",
        class: 'classe-adr',
        showClearButton: false,
        disabled: true,
        nCol: '3',
        dynamic: {
          valueExpr: 'id',
          queryString: '',
          displayExpr: '',
          dataSource: 'Adr',
          service: 'generic',
          autocomplete: false,
          checkValue: {
            checkValueMessage: '',
            forceInsert: false
          },
          caption: "Lista Classi ADR",
          componentType: 'grid',


          buttonOption: {
            text: 'Onu',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Lista Onu',
            name: 'Onu',
            location: 'after',
          }
        }

      },
      {
        type: 'campoSpecial', colVisible: false, dataField: "idONU",
        width: '3.8vw',
        nCol: '3',
        maxLength: '6',
        caption: "Onu",
        showClearButton: false,
        disabled: true,
        readonly: true,
        dynamic: {
          valueExpr: 'id',
          queryString: '',
          displayExpr: '',
          dataSource: 'onu',
          service: 'generic',
          autocomplete: false,
          checkValue: {
            checkValueMessage: '',
            forceInsert: false
          },
          caption: "Lista ONU",
          componentType: 'grid',

          buttonOption: {
            text: 'Onu',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Lista Onu',
            name: 'Onu',
            location: 'after',
          }
        }

      },
      { type: 'empty', dataField: "", dataType: "", caption: "" },

      {
        type: 'campoData',
        dataField: "dataInizioTrasporto",
        caption: "Data iniz.trasp.",
        format: "dd/MM/yyyy",
        editorType: "dxDateBox",
        dataType: "date",

        maxLength: '15',
        width: '5.5vw',
        showClearButton: false,
        colVisible: false,
        disabled: true,
        readonly: true,
      },
      {
        type: 'campoData',
        dataType: 'time',
        dataField: 'oraInizioTrasporto',
        caption: 'Ora inizio',
        disableOnUpdate: true,
        labelWidth: 5,
        colVisible: false,
        editorType: "dxDateBox",
        disabled: true,
        readonly: true,
        colWidth: '15',
        width: '5vw',
        format: 'HH:mm', mask: 'HH:mm', showClearButton: false
      },
      {
        type: 'campoData',
        dataField: "dataFineTrasporto",
        caption: "Data fine",
        format: "dd/MM/yyyy",
        editorType: "dxDateBox",
        dataType: "date",
        disabled: true,
        readonly: true,
        maxLength: '15',
        width: '6vw',
        colVisible: false,
        showClearButton: false,
        disableOnUpdate: true,
      },
      {
        type: 'campoData', dataType: 'time',
        dataField: 'oraFineTrasporto',
        caption: 'Ora fine',
        class: 'ora-fine',
        disabled: true,
        readonly: true,
        labelWidth: 5,
        colVisible: false,
        editorType: "dxDateBox",
        colWidth: '15',
        width: '3.8vw',
        format: 'HH:mm',
        mask: 'HH:mm',
        showClearButton: false,
        disableOnUpdate: true,
      },
      { type: 'empty', dataField: '', dataType: '' },

      {
        type: 'campo',
        dataField: 'numeroColli',
        class: 'quantita-origine',
        width: '5.5vw',
        caption: 'N.Colli',
        maxLength: '10',
        editorType: 'dxNumberBox',
        format: '0######',
        disabled: true,
        colVisible: false,
        readonly: true,
      },
      {
        type: 'campoSpecial',
        dataField: 'imballo_Descrizione',
        caption: 'Imballo',
        class: 'imballo',
        width: '20.8vw',
        colVisible: false,
        maxLength: '10',


        dynamic: {
          costantValue: [
            { key: 'eer', value: 'eer' }
          ],
          valueExpr: '',

          autocomplete: false,
          displayExpr: 'descrizione',
          dataSource: 'Imballo',
          related: ['id|idImballo'],
          queryString: '',
          service: 'imballo',
          caption: "Lista Imballi",
          componentType: 'dynamicGrid',
          buttonOption: {
            text: 'Onu',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Lista Onu',
            name: 'Onu',
            location: 'after',
          },
          settingGrid: settingTestiAdr
        }

      },


      {
        type: 'simpleButton', colVisible: false,
        dataField: "altriDatiFormulario",
        dataType: "",
        class: 'blueButton',
        caption: "altriDatiFormulario",

        disabled: true,
        readonly: true,
        editorClass: 'nica-plaintext-readonly',
        button: {
          text: 'Altri dati formulario',
          name: 'addDatiFormulario',
          location: 'after',
          event: "addDati",
          hint: "Specifica altri dati formulario",
          icon: "glyphicon mdi mdi-open-in-new",
          outPutValue: false,

        }
      },

      {
        type: 'campo',
        dataField: 'idImballo',
        caption: 'Imballo',
        class: 'imballo d-none',
        colVisible: false


      },
      { type: 'empty', dataField: '', dataType: '' },

      { type: 'empty', caption: ' ', dataField: '', dataType: '', colSpan: '5' },

      {
        type: 'campoSpecial',
        dataType: '',
        dataField: 'tipoAccettazione',
        caption: 'Accettazione',
        colVisible: false,
        disabled: true,
        readonly: true,
        width: '5.5vw',
        editorType: 'dxSelectBox',
        lista: {
          dataSource: 'accettazioneTipo',
          valueExpr: 'id',
          displayExpr: 'descrizione',
          static: true,
          showDropDownButton: false,
          placeholder: ' '
        }

      },
      {
        type: 'campoSpecial', dataField: "idMotivoRespinta", dataType: "", caption: "Motivo resping.",
        labelVisible: true,
        width: '6vw',
        editorType: 'dxSelectBox',
        disabled: true,
        colVisible: false,
        lista: {
          dataSource: 'MotivazioniRespingimento',
          valueExpr: 'id',
          displayExpr: 'descrizione',
          static: false,
          showClearButton: false,
          placeholder: '',
          showDropDownButton: false,

        }

      },
      {
        type: 'campo', dataField: "descrizioneRespinta", dataType: "", caption: " ",
        disabled: true,
        colVisible: false,
        labelVisible: false,
        class: 'autoLabelWidth',
        placeHolder: 'Specifica il motivo',
        width: '20vw',


      },
      { type: 'empty', dataField: '', dataType: '' },
      { type: 'empty', dataField: '', dataType: '' },

    
      {
        type: "campo", colWidth: '5px', dataField: 'spazio', caption: ' ', hideOnEdit: true
      },
      {
        type: 'campo', dataField: "quantitaRespinta", dataType: "", caption: "Peso Respinto", width: '4.688vw',
        format: '########0.###',
        maxLength: "11",
        colVisible: false,
        labelVisible: true,
        disabled: true,
        class: 'peso-respinto',
        editorType: 'dxNumberBox',
      },
      { type: 'empty', dataField: '', dataType: '' },
      { type: 'empty', dataField: '', dataType: '' },
      { type: 'empty', dataField: '', dataType: '' },



      {
        type: 'simpleButton', colVisible: false,
        dataField: "datiPesata",
        dataType: "",
        caption: "datiPesata",
        class: 'dati-pesata blueButton',
        editorClass: 'nica-plaintext-readonly',
        button: {
          text: 'Altri dati pesata',
          name: 'addDatiPesata',
          location: 'after',
          event: "addDati",
          hint: "",
          icon: "glyphicon mdi mdi-open-in-new",
          outPutValue: false,

        }
      },
      { type: 'empty', dataField: '', dataType: '' },
      { type: 'empty', dataField: '', dataType: '' },
      { type: 'empty', dataField: '', dataType: '' },

      { type: 'empty', dataField: "", dataType: "", caption: " ", colSpan: '5' },


      {
        type: 'campoSpecial', colVisible: false, dataField: "idCategoriaDocumento",

        class: 'd-none',
        dynamic: {

          costantValue: [{ key: 'nomeTabella', value: 'movimenti' }],
          queryString: '?nomeTabella=movimenti',
          dataSource: 'Categoria',
          valueExpr: 'id',
          displayExpr: '',
          service: 'generic',
          autocomplete: false,
          checkValue: {
            checkValueMessage: '',
            forceInsert: false
          },
          caption: "Lista CategoriaDocumento",
          componentType: 'grid',
          related: ['descrizione|categoriaDocumento_Descrizione'],


        }

      },
      {
        type: 'campoSpecial', colVisible: false, dataField: "categoriaDocumento_Descrizione",

        width: '15.5vw',
        labelVisible: true,
        caption: "Categoria doc.",
        disableOnUpdate: true,
        dynamic: {

          costantValue: [{ key: 'nomeTabella', value: 'movimenti' }],
          queryString: '?nomeTabella=movimenti',
          dataSource: 'Categoria',
          service: 'generic',
          autocomplete: false,

          valueExpr: '',
          displayExpr: 'descrizione',
          caption: "Lista Categorie documento",
          componentType: 'dynamicGrid',
          related: ['id|idCategoriaDocumento'],
          settingGrid: settingGridDeiDocumenti,
          buttonOption: {
            text: 'categorie',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Lista categorie',
            name: 'categorie',
            location: 'after',
          }

        }
      },
      {
        type: 'campoSpecial', colVisible: false, dataField: "idTipoDocumento",
        class: 'd-none',
        dynamic: {
          costantValue: [{ key: 'nomeTabella', value: 'soggetti' }],
          queryString: '?nomeTabella=movimenti',
          dataSource: 'Tipo',
          valueExpr: 'id',
          displayExpr: '',
          service: 'generic',
          autocomplete: false,
          related: ['descrizione|tipoDocumento_Descrizione'],


        }

      },
      {
        type: 'campoSpecial', colVisible: false, dataField: "tipoDocumento_Descrizione",
        width: '15.5vw',
        disableOnUpdate: true,
        caption: "Tipo doc.",
        class: 'tipo-doc',
        dynamic: {
          costantValue: [{ key: 'nomeTabella', value: 'movimenti' }],
          queryString: '?nomeTabella=movimenti',
          dataSource: 'Tipo',
          service: 'generic',
          autocomplete: false,

          valueExpr: '',
          displayExpr: 'descrizione',
          caption: "Lista tipo documento",
          componentType: 'dynamicGrid',
          related: ['id|idTipoDocumento'],
          settingGrid: settingGridDeiDocumenti,
          buttonOption: {
            text: 'categorie',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Lista categorie',
            name: 'categorie',
            location: 'after',
          }

        }
      },
      { type: 'empty', dataField: '', dataType: '' },


      {
        type: 'campoSpecial', colVisible: false, dataField: "zonaDocumento_Descrizione",

        width: '15.5vw',

        caption: "Zona doc.",
        disableOnUpdate: true,
        dynamic: {
          costantValue: [{ key: 'nomeTabella', value: 'movimenti' }],
          dataSource: 'Zona',
          service: 'generic',
          autocomplete: false,

          valueExpr: '',
          displayExpr: 'descrizione',
          caption: "Lista tipo documento",
          queryString: '?nomeTabella=movimenti',
          componentType: 'dynamicGrid',
          related: ['id|idZonaDocumento'],
          settingGrid: settingGridDeiDocumenti,
          buttonOption: {
            text: 'categorie',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Lista categorie',
            name: 'categorie',
            location: 'after',
          }

        }
      },
      {
        type: 'campoSpecial', colVisible: false, dataField: "idZonaDocumento",

        class: 'd-none',
        maxLength: '10',
        caption: "Zona doc.",

        dynamic: {
          costantValue: [{ key: 'nomeTabella', value: 'movimenti' }],
          dataSource: 'Zona',
          queryString: '?nomeTabella=movimenti',
          service: 'generic',
          autocomplete: false,
          valueExpr: '',
          displayExpr: 'id',
          componentType: 'grid',
          related: ['descrizione|zonaDocumento_Descrizione'],

        }

      },
      {
        type: 'campoSpecial', colVisible: false, dataField: "idBacino",
        class: 'd-none',

        dynamic: {

          dataSource: 'Zona',
          queryString: '?nomeTabella=movimenti',
          service: 'generic',
          autocomplete: false,
          valueExpr: '',
          displayExpr: 'id',
          caption: "Lista tipo documento",
          related: ['descrizione|bacinoDesc'],

        }

      },
      {
        type: 'campoSpecial', colVisible: false, dataField: "bacinoDesc",
        width: '15.5vw',


        caption: "Bacino Doc.",
        disableOnUpdate: true,
        dynamic: {
          costantValue: [{ key: 'nomeTabella', value: 'movimenti' }],
          dataSource: 'Bacino',
          service: 'generic',
          autocomplete: false,

          valueExpr: '',
          displayExpr: 'descrizione',
          caption: "Lista Bacini documento",
          queryString: '?nomeTabella=movimenti',
          componentType: 'dynamicGrid',
          related: ['id|idBacino'],
          settingGrid: settingGridDeiDocumenti,
          buttonOption: {
            text: 'bacino',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Lista categorie',
            name: 'categorie',
            location: 'after',
          }

        }
      },

      { type: 'empty', dataField: '', dataType: '' },

      { type: 'empty', dataField: '', dataType: '', colSpan: '5', caption: ' ' },

      {
        type: 'campoSpecial',
        dataField: "idCategoriaRaee",
        caption: "Cat.Raee",
        hideOnEdit: true,
        editorType: "dxSelectBox",
        dataType: "",
        visible: false,
        width: '15.5vw',

        colVisible: false,
        lista: {
          dataSource: 'Raee',
          valueExpr: 'id',
          displayExpr: 'descrizione',
          static: false
        }

      },

      {
        type: 'campo',
        dataField: "tipoRaee",
        caption: "P/D",
        hideOnEdit: true,
        dataType: "",
        editorClass: 'text-uppercase',
        class: 'tipo-raee',
        width: 2 + 'vw',
        colVisible: false,


      },

      {
        type: 'campoSpecial', dataField: 'operazioneVeicoliFuoriUso', dataType: '', caption: 'Attità Veicoli FU',
        editorType: 'dxSelectBox',
        hideOnEdit: true,
        colVisible: false,
        width: '9vw',

        class: 'veicoliFU',
        lista: {
          dataSource: 'operazioneVeicoliFuoriUso',
          valueExpr: 'id',
          displayExpr: 'descrizione',
          static: true
        }
      },
      { type: 'empty', dataField: '', dataType: '' },
      { type: 'empty', dataField: '', dataType: '' },

      {
        type: 'campoSpecial',
        dataField: "imballaggioRicevuto",
        caption: "Imballaggi",
        hideOnEdit: true,
        dataType: "",
        colVisible: false,
        editorType: 'dxRadioGroup',
        radioGroup: {

          dataSource: 'imballaggioRicevuto',
          valueExpr: 'id',
          displayExpr: 'descrizione',
          layout: 'horizontal',
          static: true,


        }

      },
      {
        type: 'campoSpecial',
        dataField: "prodottoDaImballaggi",
        caption: "Prov.da imballaggi",
        editorType: 'dxRadioGroup',
        dataType: "",

        hideOnEdit: true,
        class: 'prodottoDaImballaggi',
        colVisible: false,

        radioGroup: {

          dataSource: 'elaboraMUD',
          valueExpr: 'id',
          displayExpr: 'descrizione',
          layout: 'horizontal',
          static: true,


        }
      },
      {
        type: 'campo',
        dataField: "isAlluminio",
        caption: "Alluminio",
        editorType: "dxCheckBox",
        dataType: "boolean",
        disableOnUpdate: true,
        colVisible: false,
        defaultValue: false,
        hideOnEdit: true,

      },
      { type: 'empty', dataField: '', dataType: '' },
      { type: 'empty', dataField: '', dataType: '' },


    ]
  },


]